import React from 'react';

class ViewerErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("3D Viewer Crash:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          height: '100vh', background: '#000', color: '#B8860B', 
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
          textAlign: 'center', padding: '20px'
        }}>
          <h2>3D RENDERING ERROR</h2>
          <p>Your device or connection interrupted the 3D engine.</p>
          <button 
            onClick={() => window.location.reload()}
            style={{ 
              background: '#B8860B', color: '#000', border: 'none', 
              padding: '12px 25px', borderRadius: '50px', fontWeight: 'bold', cursor: 'pointer', marginTop: '10px' 
            }}
          >
            RELOAD ENGINE
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ViewerErrorBoundary;
